import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { AzElRangeGA2, AzelRange } from 'common/utils/constants';
import { getDefaultHeatmapRange } from 'common/utils/helpers';
import RasterHistoryHeatmap from '../../RasterHeatmap/RasterHistoryHeatmap/RasterHistoryHeatmap';
import { mapRecord } from '../utils/helpers';
import '../HeatmapViewAndExportModal.css';

function HeatmapExportableImagesContainer({ donorDevice, isGa2, forMaintHeatmap }) {
  const selectedRastersDictionary = useSelector((store) => store.ui.singleDevicePage.heatmap.selectedRastersDictionary);
  const deviceHeatmapHistoryDictionary = useSelector((store) => store.data.heatmapHistoryDictionary?.[donorDevice]);
  const config = isGa2 ? AzElRangeGA2 : AzelRange;

  // Initialize state for range
  const [range, setRange] = useState(isGa2 ? { max: -25, min: -70 } : { max: 0, min: -30 });

  useEffect(() => {
    const updateRange = async () => {
      // Loop through selected rasters to update the range
      for (const rasterId of Object.keys(selectedRastersDictionary)) {
        if (selectedRastersDictionary[rasterId]) {
          let record = await deviceHeatmapHistoryDictionary[rasterId];
          if (record.rasterId === rasterId) {
            if (record?.heatmap) {
              const values = Object.values(record?.heatmap);
              let min = range.min;
              let max = range.max;

              // Get the min and max values from the heatmap data
              const combined = values?.flat().map((num) => Math.round(num));

              min = Math.min(...combined) - 5;
              max = Math.max(...combined) + 5;

              // Update the range state
              setRange({
                min: !isNaN(min) ? min : range.min,
                max: !isNaN(max) ? max : range.max,
              });
              return;
            }
          }
        }
      }
    };

    updateRange();
  }, [selectedRastersDictionary, deviceHeatmapHistoryDictionary, range.min, range.max]);

  return (
    <div
      className="HeatmapViewAndExportModal_BackgroundHeatmapContainer"
      id="HeatmapViewAndExportModal_BackgroundHeatmapContainer"
    >
      {Object.keys(selectedRastersDictionary)
        .filter((rasterId) => selectedRastersDictionary[rasterId])
        .map((rasterId) => {
          const id = `HeatmapViewAndExportModal_HeatMapDiv_${rasterId}`;
          const record = deviceHeatmapHistoryDictionary[rasterId];
          const deviceHeatmap = mapRecord(record, isGa2 ? 'ga2' : 'ga1');

          return (
            <div id={id} key={id} className={'HeatmapViewAndExportModal_HeatMapDiv'} style={{ width: 600 }}>
              <RasterHistoryHeatmap
                config={config}
                range={range} // Using the updated range state here
                id={donorDevice}
                forViewAndExportHeatmap={true}
                forMaintHeatmap={forMaintHeatmap}
                isGa2={isGa2}
                heatmap={deviceHeatmap}
                beamrank={deviceHeatmap.beamrank}
                selectedDeviceHeatmapRecord={record}
                selectedDeviceHeatmapRasterId={rasterId}
                hidePopover={true}
              />
            </div>
          );
        })}
    </div>
  );
}

export default React.memo(HeatmapExportableImagesContainer);
